import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  ScrollView,
  Platform,
  TouchableOpacity,
  FlatList,
} from 'react-native';
import {
  ListItem,
} from 'react-native-elements';
import langmap from 'langmap';
import Header from '../../components/misc/Header';

import styles from '../../styles';
import { translate } from '../../locales/i18n';
import AORTypes from '../../types';

class SettingsAddLang extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'SettingsAddLang';

    this.handleSelectLanguage = this.handleSelectLanguage.bind(this);

    this.state = {
      allLangs: Object.keys(langmap).sort((a, b) => langmap[a].englishName > langmap[b].englishName).filter((lang) => (
        lang.indexOf('-') === -1 && lang.indexOf('_') === -1
      )),
    };
  }

  handleSelectLanguage(lang) {
    const {
      history, userData, onUpdateUser, updateUserData,
    } = this.props;

    let langs;
    if (userData.langs) {
      langs = JSON.parse(userData.langs);
    } else {
      langs = [];
    }
    langs = langs.filter((item) => item !== lang);
    langs.push(lang);
    const newUserData = { ...userData, langs: JSON.stringify(langs) };

    onUpdateUser(newUserData)
      .then(() => {
        updateUserData();
      });

    history.push('/settings');
  }

  render() {
    const { userData, history } = this.props;
    const { allLangs } = this.state;

    console.log('render');

    if (!userData) {
      console.log('no userData');

      return (
        <>
        </>
      );
    }

    return (
      <View
        style={styles.view.headed}
      >
        <Header
          name={translate('settings_languages_add')}
          hasBack
          history={history}
        />

        <ScrollView
          style={{
            flex: 1,
            ...(Platform.OS === 'web' ? {
              width: '80%',
              alignSelf: 'center',
            } : {}),
          }}
        >
          <FlatList
            style={{
              flex: 1,
              width: '100%',
            }}
            data={allLangs}
            renderItem={({ item }) => (
              <ListItem
                onPress={() => this.handleSelectLanguage(item)}
                bottomDivider
              >
                <ListItem.Content>
                  <ListItem.Title>{langmap[item].englishName}</ListItem.Title>
                  <ListItem.Subtitle>{langmap[item].nativeName}</ListItem.Subtitle>
                </ListItem.Content>
              </ListItem>
            )}
          />
        </ScrollView>
      </View>
    );
  }
}

SettingsAddLang.defaultProps = {
  userData: null,
  updateUserData: () => null,
};

SettingsAddLang.propTypes = {
  userData: AORTypes.User,
  onUpdateUser: PropTypes.func.isRequired,
  updateUserData: PropTypes.func,
  history: ReactRouterPropTypes.history.isRequired,
};

export default SettingsAddLang;
